import { node, oneOf } from "prop-types";

import { fontWeightOptions } from "../constants/fontWeightOptions";
import * as S from "./styled";

const SecondarySmall = S.SecondarySmallBase;

SecondarySmall.displayName = "SecondarySmall";

SecondarySmall.propTypes = {
  children: node.isRequired,
  weight: oneOf([fontWeightOptions.SEMI_BOLD, fontWeightOptions.REGULAR])
};

SecondarySmall.defaultProps = {
  weight: fontWeightOptions.SEMI_BOLD
};

export default SecondarySmall;
